import React, { useEffect, useState} from 'react'

export default function Privacy() {
    if (!localStorage.getItem('reloadGN')) {
        localStorage.setItem('reloadGN', 'true');
        window.location.reload();
    }
const [checked, setChecked] = useState(true);
  return (
    <div className="h-fit w-full py-12">
        <div className="mxw">
            <section>
                <p className="text-gray-500 text-md md:text-lg">Lorem ipsum dolor sit amet consectetur adipisicing elit. Et quasi ipsa ipsum vero commodi magnam. Beatae quidem ducimus laborum ut perferendis, pariatur qui autem excepturi exercitationem expedita sequi blanditiis ipsa! Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum, delectus assumenda? Eveniet sint quo quis nostrum distinctio harum velit ipsum veniam unde! Fugiat vel officiis tempore dignissimos, earum sint excepturi?</p>
                <div className="w-full h-fit py-4 text-left">
                    <p className="text-3xl font-bold">Privacy Policy</p>
                </div>

            <div className="flex items-start justify-between my-4 border-t border-gray-400 py-2">
                <div className="max-w-4xl px-3">
                    <h3 className="font-bold">Get Personalized Ads based on behavioural data</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam voluptatem numquam, dolores, eos tenetur quasi aperiam repudiandae nulla maxime sed quae recusandae quo ex ea architecto dolorem non aliquam? Minima.</p>
                </div>
                <div className="px-3">
                    <input className="scale-150" type="checkbox" />
                </div>
            </div>

            <div className="flex items-start justify-between my-4 border-t border-gray-400 py-2">
                <div className="max-w-4xl px-3">
                    <h3 className="font-bold">Get Personalized Ads based on profile matching</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam voluptatem numquam, dolores, eos tenetur quasi aperiam repudiandae nulla maxime sed quae recusandae quo ex ea architecto dolorem non aliquam? Minima.</p>
                </div>
                <div className="px-3">
                    <input className="scale-150" type="checkbox" checked={checked} onChange={() => setChecked(!checked)}/>
                </div>
            </div>
            </section>
        </div>
    </div>
  )
}
